{
  "name": "@homer.core/script",
  "version": "1.0.0",
  "type": "module",
  "private": false,
  "config": {},
  "main": "./dist/index.js",
  "module": "./src/index.js",
  "exports": {
    ".": "./src/index.js",
    "./package.json": "./package.json"
  },
  "scripts": {},
  "dependencies": {
    "@homer.core/application": "*"
  },
  "devDependencies": {},
  "requires": [],
  "loads": []
}
